export const AppFatalPage = () => {
  return (
    <h1 data-testid="application-fatal">
      The TrueNorth application failed for an unknown reason.{' '}
      <a href="/">Re-launch</a> the application.
    </h1>
  );
};
